import React from "react";
import "./style.scss";

const Layout = ({ children, bg, startQuiz }) => {
  return (
    <div
      className={`layout ${startQuiz ? "startQuiz" : ""}`}
      style={{ backgroundImage: `url(${bg})` }}
    >
      {children}
    </div>
  );
};

export default Layout;
